import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectIsCreditReportFetching } from '../selectors';
import { isWeb } from '../../../constants';
import useGetCreditReport from './useGetCreditReport';
const useCreditReportDetailItem = (hasValidId, select, navigateToParent) => {
    const dispatch = useAppDispatch();
    const item = useAppSelector(select);
    const isFetching = useAppSelector(selectIsCreditReportFetching);
    const fetchCreditReport = useGetCreditReport();
    const needsFetchRef = useRef(isWeb && hasValidId && item === undefined);
    const sawFetchingRef = useRef(false);
    const hasLeftRef = useRef(false);
    useEffect(() => {
        if (needsFetchRef.current) {
            dispatch(fetchCreditReport());
        }
    }, [dispatch, fetchCreditReport]);
    useEffect(() => {
        if (isFetching) {
            sawFetchingRef.current = true;
        }
    }, [isFetching]);
    useEffect(() => {
        const settled = !needsFetchRef.current || (sawFetchingRef.current && !isFetching);
        if (settled && !item && !hasLeftRef.current) {
            hasLeftRef.current = true;
            navigateToParent();
        }
    }, [isFetching, item, navigateToParent]);
    return item;
};
export default useCreditReportDetailItem;
